export default __webpack_public_path__ + "static/media/detailAz.86ed1a93.jpg";